
import { Component, Vue } from 'vue-property-decorator'
import { UserService } from '@/services/index'
import { setToken } from '@/common/cookies'
import { AppModule } from '@/store/modules/app'

@Component({
    name: 'App',
    components: {}
})
export default class extends Vue {
    private mounted() {
        AppModule.getCommonWords()
        // const token = getToken()
        // if (token) this.refreshToken(token)
    }

    private async refreshToken(token: string) {
        const result = await UserService.refreshToken({ token })
        if (result.status === 200) {
            setToken(result.data.token)
            // test
        }
    }
}
